import { createSlice } from "@reduxjs/toolkit";
import { set } from "lodash";
const initialState = {
  selectedLocation: null,
  locationRange: null,
  allLocationRanges: [],
  polygonGeoFence:null,
  refresh: false,
  loading: false,
  error: null,

};

const geoFenceSlice = createSlice({
  name: "geoFence",
  initialState,
  reducers: {
    setPolygonGeofence: (state, action) => {
      state.polygonGeoFence = action.payload;
    },
    clearPolygonGeofence: (state) => {
      state.polygonGeoFence = null;
    },
    setSelectedLocation: (state, action) => {
      state.selectedLocation = action.payload;
    },
    clearSelectedLocation: (state) => {
      state.selectedLocation = null;
    },
    setLocationRange: (state, action) => {
      state.locationRange = action.payload;
    },
    clearLocationRange: (state) => {
      state.locationRange = null;
    },
    setAllLocationRanges: (state, action) => {
      state.allLocationRanges = action.payload;
    },
    clearAllLocationRanges: (state) => {
      state.allLocationRanges = [];
    },
    setRefresh: (state, action) => {
      state.refresh = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase("geoFence/fetchGeoFences/pending", (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase("geoFence/fetchGeoFences/fulfilled", (state) => {
        state.loading = false;
      })
      .addCase("geoFence/fetchGeoFences/rejected", (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export const {
  setSelectedLocation,
  clearSelectedLocation,
  setLocationRange,
  clearLocationRange,
  setAllLocationRanges,
  clearAllLocationRanges,
  setRefresh,
  setPolygonGeofence,
  clearPolygonGeofence
} = geoFenceSlice.actions;

export default geoFenceSlice.reducer;